import { Tradable } from "./tradable";

export abstract class Asset extends Tradable {
	public isIota(): boolean {
		return false;
	}

	public isStellar(): boolean {
		return false;
	}

	public isWithdrawActive(): boolean {
		return this.getAssetSettings()?.isWithdrawActive() ?? false;
	}

	public isDepositActive(): boolean {
		return this.getAssetSettings()?.isDepositActive() ?? false;
	}

	public isTransferActive(): boolean {
		return this.getAssetSettings()?.isTransferActive() ?? false;
	}
}
